import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-outstandings',
    templateUrl: './credit-outstandings.component.html',
    styleUrls: ['./credit-outstandings.component.scss'],
    standalone: false
})
export class CreditOutstandingsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.setCommand([
      CommandEnum.GENERATE_TARIFICATION_BORROWER_INSURANCE,
    ]);
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
